import { render, staticRenderFns } from "./vxcomplaint.vue?vue&type=template&id=640fd0ca&scoped=true&"
import script from "./vxcomplaint.vue?vue&type=script&lang=js&"
export * from "./vxcomplaint.vue?vue&type=script&lang=js&"
import style0 from "./vxcomplaint.vue?vue&type=style&index=0&id=640fd0ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640fd0ca",
  null
  
)

export default component.exports